export default __webpack_public_path__ + "static/media/fleetmanagement.580104e2.png";